import React, { useEffect } from 'react';
import { getEvaluationTaskLabel } from '../../Util/util';
import ColoredStatus from '../../ColoredStatus/coloredStatus';
import styles from './evaluationTaskTicket.module.css';
import { LoadingSpinner } from '@qualtrics/ui-react';

const EvaluationTaskTicket = ({
    evaluationTask,
    selectedEvaluationTask,
    evaluationTaskGroup,
    evaluationPage,
    setSelectedEvaluationTask,
    setShowCompletedPage,
    setShowSurveyPage,
}) => {
    const label = getEvaluationTaskLabel(evaluationTask);
    const isSelected = selectedEvaluationTask && (
        evaluationTask.transactionId === selectedEvaluationTask.transactionId
        || evaluationTask.teacherChosenQuestionsEvaluation?.transactionId === selectedEvaluationTask.transactionId
    );

    useEffect(() => {
        const isCompletingEvaluation = () => (
            evaluationTask.transactionId === selectedEvaluationTask?.transactionId
            && evaluationTask.isBlocked
        );

        const isCompletingTeacherChosenQuestionsEvaluation = () => (
            evaluationTask.teacherChosenQuestionsEvaluation
            && evaluationTask.teacherChosenQuestionsEvaluation.transactionId === selectedEvaluationTask?.transactionId
            && evaluationTask.teacherChosenQuestionsEvaluation.isBlocked
        );

        const shouldSkipToTeacherChosenQuestions = () => (
            evaluationTask.transactionId === selectedEvaluationTask?.transactionId
            && !evaluationTask.isBlocked
            && evaluationTask.completed
            && evaluationTask.teacherChosenQuestionsEvaluation
            && !evaluationTask.teacherChosenQuestionsEvaluation.isBlocked
            && !evaluationTask.teacherChosenQuestionsEvaluation.completed
        );

        if (isCompletingEvaluation() || isCompletingTeacherChosenQuestionsEvaluation()) {
            if (evaluationTask.teacherChosenQuestionsEvaluation && !evaluationTask.teacherChosenQuestionsEvaluation.isBlocked) {
                // Direct to the teacher chosen questions evaluation when the teacher evaluation is completed
                setSelectedEvaluationTask(evaluationTask.teacherChosenQuestionsEvaluation);
            } else {
                // Direct to the next TODO evaluation task when any evaluation is completed
                const currentIndex = evaluationTaskGroup.findIndex((task) => task.transactionId === evaluationTask.transactionId);
                const nextTaskTodo = evaluationTaskGroup.slice(currentIndex).find((task) => !task.completed && !task.isBlocked)
                    || evaluationTaskGroup.slice(0, currentIndex).find((task) => !task.completed && !task.isBlocked);

                if (nextTaskTodo) {
                    setSelectedEvaluationTask(nextTaskTodo);
                } else {
                    setShowCompletedPage();
                }
            }
        } else if (shouldSkipToTeacherChosenQuestions()) {
            setShowSurveyPage();
            setSelectedEvaluationTask(evaluationTask.teacherChosenQuestionsEvaluation);
        }
    }, [evaluationTask, selectedEvaluationTask]);

    const EvaluationTaskStatus = () => {
        let isCompleted = evaluationTask.completed;

        if (evaluationTask.teacherChosenQuestionsEvaluation) {
            isCompleted = isCompleted && evaluationTask.teacherChosenQuestionsEvaluation.completed;
        }

        return (
            <ColoredStatus 
                status={isCompleted ? 'Done' : 'Todo'}
                translatedStatus={isCompleted ? evaluationPage.evaluationComplete : evaluationPage.evaluationIncomplete}
                className={styles['evaluation-task-status']}
            />
        );
    };

    const onClick = () => {
        if (evaluationTask.isBlocked) {
            if (evaluationTask.teacherChosenQuestionsEvaluation && !evaluationTask.teacherChosenQuestionsEvaluation.isBlocked) {
                return setSelectedEvaluationTask(evaluationTask.teacherChosenQuestionsEvaluation);
            }

            return undefined;
        }

        return setSelectedEvaluationTask(evaluationTask);
    };

    const isTicketLoading = () => {
        if (evaluationTask.teacherChosenQuestionsEvaluation) {
            return evaluationTask.teacherChosenQuestionsEvaluation.isBlocked;
        }

        return evaluationTask.isBlocked;
    };


    return (
        <LoadingSpinner
            className={
                `${isSelected ? styles['selected-evaluation-ticket-wrapper'] : ''} 
                ${evaluationTask.isBlocked ? styles['blocked-evaluation-ticket-wrapper'] : ''} 
                ${styles['evaluation-ticket-wrapper']}`
            }
            size="small"
            onClick={onClick}
            show={isTicketLoading()}
            disabled={evaluationTask.isBlocked || evaluationTask.teacherChosenQuestionsEvaluation?.isBlocked}
            background="fade"
        >
            <div className={styles['evaluation-ticket-content']}>
                <div className={styles['ticket-label']}>
                    <EvaluationTaskStatus />
                    {label}
                </div>
            </div>
        </LoadingSpinner>
    );
};

export default EvaluationTaskTicket;
